import { call, put, takeLatest } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_EVENT_LOG = 'FETCH_EVENT_LOG';
export const FETCH_EVENT_LOG_SUCCESS = 'FETCH_EVENT_LOG_SUCCESS';
export const FETCH_EVENT_LOG_FAIL = 'FETCH_EVENT_LOG_FAIL';
export const CLEAR_EVENT_LOG = 'CLEAR_EVENT_LOG';

export const FETCH_EVENT_LOG_ITEM = 'FETCH_EVENT_LOG_ITEM';
export const FETCH_EVENT_LOG_ITEM_SUCCESS = 'FETCH_EVENT_LOG_ITEM_SUCCESS';
export const FETCH_EVENT_LOG_ITEM_FAIL = 'FETCH_EVENT_LOG_ITEM_FAIL';

export const FETCH_EVENT_LOG_ITEM_DIFF = 'FETCH_EVENT_LOG_ITEM_DIFF';
export const FETCH_EVENT_LOG_ITEM_DIFF_SUCCESS = 'FETCH_EVENT_LOG_ITEM_DIFF_SUCCESS';
export const FETCH_EVENT_LOG_ITEM_DIFF_FAIL = 'FETCH_EVENT_LOG_ITEM_DIFF_FAIL';

// Reducer
export default function eventLogReducer(state = { data: [], count: 0, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_EVENT_LOG:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_EVENT_LOG_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_EVENT_LOG_ITEM_DIFF_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Diff ID'] !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          Diff: payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case FETCH_EVENT_LOG_FAIL:
    case FETCH_EVENT_LOG_ITEM_DIFF_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_EVENT_LOG:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchEventLog(payload) {
  return { type: FETCH_EVENT_LOG, payload };
}

export function fetchEventLogSuccess(payload) {
  return { type: FETCH_EVENT_LOG_SUCCESS, payload };
}

export function fetchEventLogFail(payload) {
  return { type: FETCH_EVENT_LOG_FAIL, payload };
}

export function clearEventLog(payload) {
  return { type: CLEAR_EVENT_LOG, payload };
}

export function fetchEventLogItem(payload) {
  return { type: FETCH_EVENT_LOG_ITEM, payload };
}

export function fetchEventLogItemSuccess(payload) {
  return { type: FETCH_EVENT_LOG_ITEM_SUCCESS, payload };
}

export function fetchEventLogItemFail(payload) {
  return { type: FETCH_EVENT_LOG_ITEM_FAIL, payload };
}

export function fetchEventLogItemDiff(payload) {
  return { type: FETCH_EVENT_LOG_ITEM_DIFF, payload };
}

export function fetchEventLogItemDiffSuccess(payload) {
  return { type: FETCH_EVENT_LOG_ITEM_DIFF_SUCCESS, payload };
}

export function fetchEventLogItemDiffFail(payload) {
  return { type: FETCH_EVENT_LOG_ITEM_DIFF_FAIL, payload };
}

// Requests
export function requestSearchEventLog({ limit, offset, filters }) {
  return callApi('event_log/patient/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'Create At',
        sort: 'desc',
      },
    ],
    limit,
    offset,
  });
}

export function requestFetchEventLogItemDiff(payload) {
  return callApi(`event_log/diff/?id=${payload}`);
}

export function requestFetchEventLogItem(payload) {
  return callApi(`event_log/patient/?id=${payload}`);
}

// Sagas
function* fetchEventLogSaga(action) {
  const { triggerLoading, push } = action.payload;
  try {
    const res = yield call(requestSearchEventLog, action.payload);
    if (res.count === 0) {
      yield put(fetchEventLogSuccess({
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    } else if (push) {
      yield put(fetchEventLogSuccess({
        push: true,
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    } else {
      yield put(fetchEventLogSuccess({
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchEventLogFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* fetchEventLogItemDiffSaga(action) {
  const { triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchEventLogItemDiff, action.payload['Diff ID']);
    if (res.data.ID) {
      yield put(fetchEventLogItemDiffSuccess({
        ...res.data,
        triggerLoading,
      }));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    } else {
      yield put(fetchEventLogItemDiffFail({
        triggerLoading,
      }));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchEventLogItemDiffFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* fetchEventLogItemSaga(action) {
  const { triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchEventLogItem, action.payload.ID);
    if (res.data.ID) {
      yield put(fetchEventLogItemSuccess({
        ...res.data,
        triggerLoading,
      }));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    } else {
      yield put(fetchEventLogItemFail({
        triggerLoading,
      }));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchEventLogItemFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

export function* eventLogSaga() {
  yield takeLatest(FETCH_EVENT_LOG, fetchEventLogSaga);
  yield takeLatest(FETCH_EVENT_LOG_ITEM_DIFF, fetchEventLogItemDiffSaga);
  yield takeLatest(FETCH_EVENT_LOG_ITEM, fetchEventLogItemSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/eventLog.js